export default __webpack_public_path__ + "static/media/u_5.d4729d19.png";